/** Marta’s seven MIM language versions: English plus these translations. */
export const MIM_LAUNCH_LANGUAGE_CODES = ['fr', 'de', 'nl', 'es', 'it', 'pl'] as const
